import request from '@/utils/request'

// 新增业务在线申请管理
export function addPxsb(data) {
  return request({
    url: '/web/xwqy/wmcxylpxsb',
    method: 'post',
    data: data
  })
}
